import BrainboxPort from './brainbox_port.js';

/**
 * Opens a URL preferentially via the Wavebox extension so the tab lands in the
 * user's current Space/partition rather than the default profile. Falls back
 * to `window.open` if the extension isn't connected, doesn't reply within
 * BRIDGE_TIMEOUT_MS, or rejects the request.
 *
 * @param {string} url - The URL to open.
 * @param {{ elevate?: boolean }} [options]
 *   - `elevate`: ask the extension to promote a tab-scoped side panel to
 *     window scope before opening (mirrors the first-tool-call behaviour).
 *     Use for deliberate user navigation (e.g. "Further reading" chips) so
 *     the brainbox panel doesn't close when the bound tab navigates away.
 */

const BRIDGE_TIMEOUT_MS = 1000;

export async function openInWavebox(url, options = {}) {
  if (!url) return;

  const { elevate = false } = options;

  if (!BrainboxPort.isConnected) {
    openFallback(url);
    return;
  }

  const timeoutPromise = new Promise((resolve) => {
    setTimeout(() => resolve({ outcome: 'timeout' }), BRIDGE_TIMEOUT_MS);
  });

  const bridgePromise = BrainboxPort.request('openLink', { url, elevate })
    .then(() => ({ outcome: 'ok' }))
    .catch((err) => ({ outcome: 'error', err }));

  const { outcome, err } = await Promise.race([bridgePromise, timeoutPromise]);

  if (outcome === 'ok') return;

  if (outcome === 'timeout') {
    console.warn(
      `[WaveboxLinkOpener] Extension did not reply within ${BRIDGE_TIMEOUT_MS}ms; falling back to window.open`
    );
  } else {
    console.warn('[WaveboxLinkOpener] Bridge rejected openLink; falling back to window.open', err);
  }

  openFallback(url);
}

function openFallback(url) {
  window.open(url, '_blank', 'noopener,noreferrer');
}
